import FormSpecKey from './enums/FormSpecKey';
import FormSpecRegistry from './FormSpecRegistry';
import { formSpecRegistryV2 } from '../specs/pexbd-v2.spec';
import { formSpecRegistryV3 } from '../specs/pexbd-v3.spec';

// ici on ajoute toutes les specs qui seront rendues par FormPEXBD_V2
const formSpecRegistries: Partial<Record<FormSpecKey, FormSpecRegistry>> = {
  [FormSpecKey.PEXBD_V2]: formSpecRegistryV2,
  [FormSpecKey.PEXBD_V3]: formSpecRegistryV3,
};

export const getFormSpecRegistryForKey = (specKey: FormSpecKey): FormSpecRegistry => {
  const registry = formSpecRegistries[specKey];
  if (!registry) {
    throw new Error(`Aucun registry pour la spec : ${specKey}`);
  }
  return registry;
};

/** Specs rendues par `FormPEXBD_V2` (moteur dynamique v2+). */
export const isDynamicFormSpecKey = (specKey: FormSpecKey | null): specKey is FormSpecKey => (
  specKey !== null && specKey in formSpecRegistries
);

export const FORM_SPEC_OPTIONS: { specKey: FormSpecKey; label: string }[] = [
  { specKey: FormSpecKey.PEXBD_V3, label: 'PEXBD v3' },
  { specKey: FormSpecKey.PEXBD_V2, label: 'PEXBD v2' },
  { specKey: FormSpecKey.PEXBD_V1_GROUP1, label: 'PEXBD v1 — groupe 1' },
  { specKey: FormSpecKey.PEXBD_V1_GROUP2, label: 'PEXBD v1 — groupe 2' },
];

/** Specs visibles dans « Nouveau formulaire ». Retirer une clé pour la masquer (ex. PEXBD_V2 quand v3 sera prête). */
// ici on ajoute toutes les specs qui seront créables par l'utilisateur
export const CREATABLE_SPEC_KEYS: FormSpecKey[] = [
  FormSpecKey.PEXBD_V2,
  FormSpecKey.PEXBD_V3,
];

export const getCreatableFormSpecOptions = () => (
  FORM_SPEC_OPTIONS.filter((option) => CREATABLE_SPEC_KEYS.includes(option.specKey))
);

export default formSpecRegistries;
